import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ServiceBase } from "./servicebase";

@Injectable()
export class ClaimPolicyService extends ServiceBase {
  claimPolicyServiceUrl = '';
  constructor(private http: HttpClient) {
    super();
    this.claimPolicyServiceUrl = this.apiBaseUrl +  'claimpolicy/';
  }

  put(claimPolicyUpdateModel){
    return this.http.put(this.claimPolicyServiceUrl, claimPolicyUpdateModel);
  }
}
